module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/179.f62b2743.png";